import { SearchComponentsPaginatedParameters } from "../../services/http/component/models/SearchComponentsPaginatedParameters";
import { ComponentTableViewModel } from "./ComponentTableViewModel";
import { TableColumn } from "./ResultsTable/TableWrapper";

// Columns
export const tableColumns: TableColumn[] = [
    { label: "Health", sortable: true, sticky: true },
    { label: "Name", sortable: true, sticky: true },
    { label: "Last Value", visible: true },
    {
        label: "Last 24 hours",
        visible: true,
        group: [{ label: "Day Average" }, { label: "Day Min" }, { label: "Day Max" }]
    },
    {
        label: "Last 30 days",
        visible: true,
        group: [{ label: "Month Average" }, { label: "Month Min" }, { label: "Month Max" }]
    }
];

// Interfaces
export interface TableState
{
    data: ComponentTableViewModel;
    filters: SearchComponentsPaginatedParameters;
    configuration: {
        density: string;
        visibleSections: TableColumn[];
    };
}

export interface SortUpdate
{
    sortBy: string;
    sortOrder: number;
}

export interface FiltersUpdate
{
    text?: string;
    flags?: number;
    onlyOffline?: boolean;
    sortBy?: string;
    sortOrder?: number;
    pageSize?: number;
    pageNumber?: number;
}

export interface ConfigurationUpdate
{
    density?: string;
    visibleSections?: TableColumn[];
}

// Enums
export enum StateUpdate
{
    Data,
    Filters,
    Configuration
}